import React from "react";
import { Box } from "@mui/material";
import SystemRelationStep from "./SystemRelationStep.tsx";
import { useDotLegalQueryWithKey } from "../../../../common/hooks/dotLegalReactQuery.ts";

export interface SystemAssociatedAssetsFieldProps {
    systemId: string;
    disableSystemRelations: boolean;
    onDisableSystemRelationsChange: (checked: boolean) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function SystemAssociatedAssetsField(props: SystemAssociatedAssetsFieldProps) {
    const relationQuery = useDotLegalQueryWithKey<Array<string>>("systemRelation" + props.systemId, "/systemRelation/" + props.systemId, {
        enabled: !props.isPreview,
    });

    return (
        <>
            <SystemRelationStep
                id={props.systemId}
                isLoading={relationQuery.isLoading && !props.isPreview}
                relatedSystems={relationQuery.data ?? []}
                readOnly={props.disabled}
                disableSystemRelations={props.disableSystemRelations}
                onDisableSystemRelationsChange={props.readOnly ? () => {} : props.onDisableSystemRelationsChange}
            />

            {props.errorText && (
                <Box
                    sx={(theme) => ({
                        fontSize: theme.typography.pxToRem(12),
                        color: theme.palette.error.main,
                        textAlign: "center",
                        marginTop: theme.spacing(2),
                    })}
                >
                    {props.errorText}
                </Box>
            )}
        </>
    );
}

export default SystemAssociatedAssetsField;
